import { useQuery } from '@tanstack/react-query'
import { api } from '..'

export type TEmailRecipient = {
  id: string
  email: string
}

export const getEmailRecipients = (alertRuleId: string) =>
  api
    .get<TEmailRecipient[]>(`/v1/alert-rules/${alertRuleId}/email-recipients`)
    .then(({ data }) => data)

export const useGetEmailRecipients = (alertRuleId?: string) => {
  if (!alertRuleId) throw new Error('Missing alertRuleId')

  return useQuery({
    queryKey: ['alertRule', alertRuleId, 'emailRecipients'],
    queryFn: () => getEmailRecipients(alertRuleId),
  })
}
